/** @format */
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { Attainment, StudyRightModuleSelection } from 'common-typescript/types';
import { ComponentDowngradeMappings, DowngradedComponent, StaticMembers } from 'sis-common';

@StaticMembers<DowngradedComponent>()
@Component({
    selector: 'sis-module-selection',
    templateUrl: './module-selection.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class ModuleSelectionComponent {
    static downgrade: ComponentDowngradeMappings = {
        moduleName: 'sis-components.studyRight.moduleSelectionsNg',
        directiveName: 'sisModuleSelection',
    };

    @Input() selection: StudyRightModuleSelection;
    @Input() attainment: Attainment;
    @Input() canDelete = false;
    @Output() deleteCallback = new EventEmitter<void>();
}
